// Color palette used to colour-code saved simulations in the batch panel
// and the comparison modal.  Indexed by save order, wraps after 10.
export const SIM_COLORS = [
  '#00d4ff', '#ff6b6b', '#ffd700', '#00ff88',
  '#ff00ff', '#ff8800', '#00ffff', '#ff0066',
  '#88ff00', '#8800ff',
];
